import ListTemplate from "../_templates/ListTemplate";
import BulkDeleteAction from "../../../components/common/BulkDeleteAction";
import { listUmpires, deleteUmpire } from "../../../api/coredata.api";
import useNationalities from "../../../hooks/useNationalities";
import useAuthStore from "../../../store/auth.store";

const ROLE_TONE = {
  UMPIRE:  "bg-button-primary/20 text-button-primary border-button-primary/40",
  REFEREE: "bg-amber-500/15 text-amber-300 border-amber-400/30",
};
const Pill = ({ value, tone }) =>
  value ? (
    <span className={`inline-block text-[10px] uppercase tracking-wider rounded-full px-2 py-0.5 border ${tone || "bg-bg-secondary text-text-secondary border-border-default"}`}>
      {value}
    </span>
  ) : null;

export default function UmpireList() {
  const { nameOf } = useNationalities();
  const isSuperuser = useAuthStore((s) => !!s.user?.is_superuser);
  return (
    <ListTemplate
      title="Umpires"
      fetchFn={listUmpires}
      deleteFn={deleteUmpire}
      getAddPath={() => "/cricket/umpires/add"}
      getEditPath={(id) => `/cricket/umpires/${id}/edit`}
      bulkActions={isSuperuser ? (ids, reset, reload) => (
        <BulkDeleteAction ids={ids} deleteFn={deleteUmpire} label="umpires" reset={reset} reload={reload} />
      ) : undefined}
      columns={[
        // Show the canonical display label (server-computed:
        // short_name > "First Last" > first name) so the list isn't
        // just first names. The raw `name` column was kept on the
        // legacy mockups but operators consistently want the display
        // name on screens that don't double as a name editor.
        { key: "display_label", label: "Name", render: (r) => <span className="font-medium">{r.display_label || r.name}</span> },
        { key: "role",        label: "Role",      render: (r) => <Pill value={r.role} tone={ROLE_TONE[r.role]} /> },
        { key: "nationality", label: "Country",   render: (r) => nameOf(r.nationality) },
        { key: "date_of_birth", label: "DOB",     render: (r) => r.date_of_birth || "—" },
      ]}
    />
  );
}
